import React from 'react';
import PDescriptionLogic from './PDescriptionLogic';
import {Layout, Tabs, Typography, Card} from 'antd';
import appColors from '../../style/theme';
const {Content} = Layout;
const {Text} = Typography;
const items_ = [
  {label: <Card
    style={{
      width: 300,
      background: appColors['ColorA'],
      margin: '-8px -16px -10px -16px',
    }}
    cover={
      <img
        src="https://static.igem.wiki/teams/4464/wiki/home/overview5.png"
        height = "300vh"
      />
    }
  >
    <Text>Project Description</Text>
  </Card>, key: 'fh', children: <PDescriptionLogic/>},
];

const PDescriptionPage = () => {
  return (
    <Layout style={{background: 'transparent'}}>
      <Content>
        <Tabs
          centered='true'
          defaultActiveKey="1"
          type="card"
          items={items_}
        />
      </Content>
    </Layout>
  );
};

export default PDescriptionPage;
